import React, { useEffect, useState } from "react";
import { Card, CardActions, CardContent, Button, Typography, CardHeader, IconButton, Tooltip, Modal, Box, Grid2 } from "@mui/material";
import { Close } from "@mui/icons-material"
import { GetObjectCommand, S3Client } from "@aws-sdk/client-s3";
import { getSignedUrl } from "@aws-sdk/s3-request-presigner";
import { Facebook, Instagram, YouTube } from "@mui/icons-material";
import { DateTime } from "luxon";

export default function ImgMediaCard(props) {
  const [url, setURL] = useState("");
  const [open, setOpen] = useState(false);
  const [expDate, setExpDate] = useState("");
  const ambassador = props.ambassador;
  const onlineSiteWithBrandAmbCode = "https://www.jeanswarehousehawaii.com/discount/" + ambassador.code;
  const googleMapsSite = "https://www.google.com/maps/search/Jeans+Warehouse+Local+Fever";
  const instagramLink = "https://www.instagram.com/jeanswarehousehawaii";
  const facebookLink = "https://www.facebook.com/jeanswarehousehawaii";
  const youtubeLink = "https://www.youtube.com/channel/UCvn5g4e0LUGx9aqq9TaSEXQ";

  const handleClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    const client = new S3Client({ region: process.env.REACT_APP_S3_REGION, credentials: { accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID, secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY }})
    const command = new GetObjectCommand({ Bucket: process.env.REACT_APP_BUCKET, Key: `${ambassador.code}.svg` })
    const now = DateTime.now();
    const endOfMonth = now.plus({ days: -(now.day), months: 1 }).toFormat("MM/dd/yyyy");
    setExpDate(endOfMonth.toString("MM/dd/yyyy"))

    getQrCode();

    async function getQrCode() {
      const response = await getSignedUrl(client, command, {expiresIn: 86400 })
      
      await fetch(response)
        .then(({ status }) => {
          if (status === 200) {
            setURL(response);
          } else {
            setURL("");
          }
        })
        .catch(err => {
          console.error(err);
          setURL("");
        });
    }
  }, [ambassador.code]);

  return (
    <div className="centered">
      <Card className="card">
        <CardContent>
          <img
            alt="Jeans Warehouse Logo"
            src="https://cdn.shopify.com/s/files/1/1192/3640/files/LOGO-LONG_35d55d35-f645-4866-b93b-094021efab86.svg"
            />
          <CardHeader className="card-header" title="Brand Ambassador" />
          <Typography variant="body2" color="textSecondary" component="p" className="card-text">
            Provide this QR code when you arrive at Jeans Warehouse or Local Fever stores.
          </Typography>
          <div className="qrcode">
            {url !== "" ?
              <img
              height="256px"
              width="256px"
              alt={`Svg of ${ambassador.code} QR Code`}
              src={url} />
              :
              <Typography variant="body2">
                  QR Code Not Found
              </Typography>
            }
          </div>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-title"
            aria-describedby="modal-description"
          >
            <Box style={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh", backgroundColor: "white" }}>
              <Grid2 style={{ textAlign: "center" }}>
                <h2 id="modal-title">
                  {ambassador.code}
                </h2>
                <Typography component="p" className="card-text">
                  QR code valid until {expDate}
                </Typography>
                <img
                  className="modal-image"
                  src={url}
                  alt={`Svg of ${ambassador.code} QR Code`}
                />
                <div>
                  <IconButton aria-label={"Close modal of Ambassador's QR Code"} onClick={() => setOpen(false)}>
                    <Close alt="Close Icon" />
                  </IconButton>
                </div>
              </Grid2>
            </Box>
          </Modal>
          <Typography
            gutterBottom
            variant="h5"
            component="h2"
            className="card-text"
            >
              <Typography variant="body2" color="textSecondary" component="p" className="card-text">
                QR code valid until {expDate}
              </Typography>
              {ambassador.code}
          </Typography>
            <Button type="button" onClick={() => setOpen(true)} fullWidth={true}>
                Enlarge QR Code
            </Button>
          <Typography variant="body2" color="textSecondary" component="p" className="card-text">
            Use the code when shopping online.
          </Typography>
        </CardContent>
        <CardActions className="centered">
          <Button size="small" color="primary" href={googleMapsSite}>
            Store Locations
          </Button>
          <Button size="small" color="primary" href={onlineSiteWithBrandAmbCode}>
            Shop Online Now
          </Button>
        </CardActions>
        <CardActions className="centered">
          <Tooltip title="Follow us on Instagram" arrow>
            <IconButton aria-label="Follow us on Instagram" href={instagramLink} target="_blank" rel="noopener noreferrer">
              <Instagram alt="Instgram logo" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Follow us on Facebook" arrow>
            <IconButton aria-label="Follow us on Facebook" href={facebookLink} target="_blank" rel="noopener noreferrer">
              <Facebook alt="Facebook logo" />
            </IconButton>
          </Tooltip>
          <Tooltip title="Follow us on YouTube" arrow>
            <IconButton aria-label="Follow us on YouTube" href={youtubeLink} target="_blank" rel="noopener noreferrer">
              <YouTube alt="YouTube logo" />
            </IconButton>
          </Tooltip>
        </CardActions>
      </Card>
    </div>
  );
}
